<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="窗口期" prop="windowTimeList" class="is-required">
                    <el-select v-model="queryCondition.windowTimeList" clearable multiple placeholder="请选择(支持多选)" style="width:100%" class="multiple_sel">
                      <el-option v-for="item in windowTimeList" :label="item.name" :value="item.code" :key="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="产品编码" prop="griCode">
                    <el-input v-model="queryCondition.griCode" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="产品中文名称" prop="griDescription">
                    <el-input v-model="queryCondition.griDescription" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="产品英文名称" prop="griName">
                    <el-input v-model="queryCondition.griName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="Category2" prop="categoryLevel2CodesList">
                      <el-select v-model="queryCondition.categoryLevel2CodesList" @change="changeCategory2" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%" class="multiple_sel">
                        <el-option v-for="item in categoryList2" :label="item.name" :value="item.code" :key="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="Category3" prop="categoryLevel3CodesList">
                      <el-select v-model="queryCondition.categoryLevel3CodesList" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%" class="multiple_sel">
                        <el-option v-for="item in categoryList3" :label="item.name" :value="item.code" :key="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="波动比例超过20%" prop="alertFlag">
                      <el-select v-model="queryCondition.alertFlag" clearable placeholder="请选择" style="width:100%">
                        <el-option v-for="item in alertFlagOptions" :label="item.name" :value="item.code" :key="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onFinalization" :disabled="isFinalDisabled" :loading="isFinalLoading" v-acl="NUTR_REPORT_CONFIRM_EDITION">定版</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onPublish" :disabled="isPublishDisabled" :loading="isPublishLoading" v-acl="NUTR_REPORT_RELEASE">发布</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onExport" v-acl="NUTR_REPORT_DOWNLOAD">导出</el-button>
      </el-row>
      <el-row>
        <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-for="(item,index) in tabLists" :key="index" :name="item.key" :label="item.label">
            <el-table :data="item.currentDetailList" :cell-class-name="cellClassName" row-key="REPORT_ID" :expand-row-keys="expandKeys" @expand-change="expandChange" ref="refTable" max-height="425" border style="width: 100%" class="nutritionTable">
              <el-table-column type="expand">
                <template slot-scope="scope">
                  <el-table :data="scope.row.childDetailList" :cell-class-name="cellClassName" max-height="425" border row-key="REPORT_ID" class="nutritionTable" style="width:calc(100% - 34px);margin-left:41px!important">
                    <el-table-column v-for="(item,index) in childTableHeaderList" :prop="item.prop" :label="item.label" width="150" :key="index">
                      <template slot-scope="scope">
                        <el-tooltip v-if="scope.row[item.prop]&&scope.row[item.prop+'_GAP_REASON']" effect="dark" :content="scope.row[item.prop+'_GAP_REASON']" placement="top">
                          <p class="nutrition_p">
                            <el-button @click="onViewChildReason(scope.row,item.prop,item.label)" v-if="item.prop!='WINDOW_TIME'&&item.prop!='ATTACHMENTINFO'&&item.prop!='CURRENT_IMPACT'&&item.prop!='FIVE_BIT_CODE'&&item.prop!='INSPECT_ID'&&item.prop!='VERSION'&&item.prop!='BE_SELECTED_REASON'&&item.prop!='FACILITY_NAME'&&item.prop!='DELIVERY_RATIO'" type="text">{{scope.row[item.prop]}}</el-button>
                            <span v-else>{{scope.row[item.prop]}}</span>
                          </p>
                        </el-tooltip>
                        <p class="nutrition_p" v-else>
                          <el-button @click="onViewChildReason(scope.row,item.prop,item.label)" v-if="item.prop!='WINDOW_TIME'&&item.prop!='ATTACHMENTINFO'&&item.prop!='CURRENT_IMPACT'&&item.prop!='FIVE_BIT_CODE'&&item.prop!='INSPECT_ID'&&item.prop!='VERSION'&&item.prop!='BE_SELECTED_REASON'&&item.prop!='FACILITY_NAME'&&item.prop!='DELIVERY_RATIO'" type="text">{{scope.row[item.prop]}}</el-button>
                          <el-button v-else-if="item.prop=='FIVE_BIT_CODE'" type="text" @click="goToNutritionDetail(scope.row)">{{scope.row[item.prop]}}</el-button>
                          <el-button v-else-if="item.prop=='VERSION'" type="text" @click="onViewDetail(scope.row)">{{scope.row[item.prop]}}</el-button>
                          <el-button v-else-if="item.prop=='ATTACHMENTINFO'" type="text" @click="onViewFile(scope.row)">附件</el-button>
                          <span v-else>{{scope.row[item.prop]}}</span>
                        </p>
                        <p class="nutrition_p_span" v-if="scope.row[item.prop+'_ALERT_FLAG']=='Y'&&scope.row[item.prop+'_GAP_PERCENT_PRE_WINDOW']">
                          <i :class="Number(scope.row[item.prop+'_GAP_PERCENT_PRE_WINDOW'])>0?'el-icon-top':'el-icon-bottom'"></i>
                          <span>{{Math.abs(scope.row[item.prop+'_GAP_PERCENT_PRE_WINDOW'])+'%'}}</span>
                        </p>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column v-for="(item,index) in item.tableHeaderList" :prop="item.prop" :label="item.label" width="150" :key="index">
                <template slot-scope="scope">
                  <el-tooltip v-if="scope.row[item.prop]&&scope.row[item.prop+'_GAP_REASON']" effect="dark" :content="scope.row[item.prop+'_GAP_REASON']" placement="top">
                    <el-button @click="onViewReason(scope.row,item.prop,item.label)" v-if="item.prop!='WINDOW_TIME'&&item.prop!='CURRENT_IMPACT'&&item.prop!='GRI_CODE'&&item.prop!='DESCRIBE'&&item.prop!='FIVE_BIT_CODE_NAME'&&item.prop!='CATEGORY_LEVEL2_NAME'&&item.prop!='CATEGORY_LEVEL3_NAME'&&item.prop!='COOK_CODE'" type="text">{{scope.row[item.prop]}}</el-button>
                    <p v-else class="nutrition_p">{{scope.row[item.prop]}}</p>
                  </el-tooltip>
                  <p class="nutrition_p" v-else>
                    <el-button @click="onViewReason(scope.row,item.prop,item.label)" v-if="item.prop!='WINDOW_TIME'&&item.prop!='CURRENT_IMPACT'&&item.prop!='GRI_CODE'&&item.prop!='DESCRIBE'&&item.prop!='FIVE_BIT_CODE_NAME'&&item.prop!='CATEGORY_LEVEL2_NAME'&&item.prop!='CATEGORY_LEVEL3_NAME'&&item.prop!='COOK_CODE'" type="text">{{scope.row[item.prop]}}</el-button>
                    <span v-else>{{scope.row[item.prop]}}</span>
                  </p>
                  <p class="nutrition_p_span" v-if="scope.row[item.prop+'_ALERT_FLAG']=='Y'&&scope.row[item.prop+'_GAP_PERCENT_PRE_WINDOW']">
                    <i :class="Number(scope.row[item.prop+'_GAP_PERCENT_PRE_WINDOW'])>0?'el-icon-top':'el-icon-bottom'"></i>
                    <span>{{Math.abs(scope.row[item.prop+'_GAP_PERCENT_PRE_WINDOW'])+'%'}}</span>
                  </p>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-row>
      <el-dialog title="波动原因备注" :visible.sync="dialogVisible1" width="30%" :close-on-click-modal="false" @close="onClose1" class="fpa">
        <el-form ref="remarkForm" :model="remarkForm" label-width="100px">
          <el-form-item label="产品编码" prop="griCode">
            <el-input v-model="remarkForm.griCode" disabled></el-input>
          </el-form-item>
          <el-form-item label="产品中文名称" prop="griName">
            <el-input v-model="remarkForm.griName" disabled></el-input>
          </el-form-item>
          <el-form-item label="工厂名称" prop="plantName" v-if="isDisplay">
            <el-input v-model="remarkForm.plantName" disabled></el-input>
          </el-form-item>
          <el-form-item label="Nutrition指标" prop="indicators">
            <el-input v-model="remarkForm.indicators" disabled></el-input>
          </el-form-item>
          <el-form-item label="波动原因备注" prop="gapReason" :rules="{required: true, message: '波动原因备注必填', trigger: 'blur'}">
            <el-input v-model="remarkForm.gapReason" type="textarea" :rows="4" maxlength="1000" show-word-limit :disabled="!isEdit"></el-input>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button size="mini" class="btn" type="primary" @click="onSaveNote" :disabled="isSaveDisabled" :loading="isSaveLoading" v-if="isEdit">保存</el-button>
          <el-button size="mini" class="btn" @click="onClose1">取消</el-button>
        </el-row>
      </el-dialog>
      <el-dialog title="附件信息" :visible.sync="dialogVisible2" width="70%" :close-on-click-modal="false" @close="onClose2" class="fpa">
        <el-table :data="fileTableData" ref="fileTable" max-height="326px" border size="small" style="width: 100%">
          <el-table-column label="序号" type="index" min-width="50px"></el-table-column>
          <el-table-column label="附件类型" prop="attachmentTypeText" show-overflow-tooltip min-width="100px">
            <!-- <template slot-scope="scope">
              <ic-select v-model="scope.row.seq" table="TT_NUTR_INSPECT" field="ATTACHMENT_TYPE" disabled style="width:100%"></ic-select>
            </template> -->
          </el-table-column>
          <el-table-column label="附件名称" prop="documentName" show-overflow-tooltip min-width="180px">
            <template slot-scope="scope">
              <el-button type="text" @click="onDownload(scope.row)">{{scope.row.documentName}}</el-button>
            </template>
          </el-table-column>
          <el-table-column label="上传人" prop="uploadBy" show-overflow-tooltip min-width="100px"></el-table-column>
          <el-table-column label="上传时间" prop="uploadTime" show-overflow-tooltip min-width="100px"></el-table-column>
        </el-table>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button size="mini" class="btn" @click="onClose2">返回</el-button>
        </el-row>
      </el-dialog>
      <el-dialog title="Nutrition修改" :visible.sync="dialogVisible3" width="80%" :close-on-click-modal="false" @close="onClose3" class="fpa">
        <detailDialog :detailObj="detailObj" @closeDetail="closeDetail" @onClose3="onClose3"></detailDialog>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import nutriApi from "@/api/Nutrition/index";
import paginationMixin from '@/mixins/pagitionMixin';
import { apiService } from "@/api/material/material-master-data";
import { fileService } from "@/api/common/file-utils";
import IcSelect from "@/components/common/icSelect";
import { inputChoiceService } from "@/api/common/input-choice";
import detailDialog from "./griNutritionAnalysisDetail.vue"
import store from '@/store/index'
export default {
  mixins: [paginationMixin],
  components: { IcSelect, detailDialog },
  data() {
    return {
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        windowTimeList: [],
        griCode: "",
        griName: "",
        griDescription: "",
        categoryLevel2CodesList: [],
        categoryLevel3CodesList: [],
        alertFlag: '',
      },
      totalCount: 0,
      pages: 1,
      isShow: false,
      dialogVisible1: false,//波动原因备注
      dialogVisible2: false,//附件信息
      dialogVisible3: false,//Nutrition修改
      isDisplay: false,//工厂名称字段是否显示
      isEdit: false,//波动原因是否可编辑
      isFinalDisabled: false,
      isFinalLoading: false,
      isPublishDisabled: false,
      isPublishLoading: false,
      isSaveDisabled: false,
      isSaveLoading: false,
      // 窗口期数据
      childDetailList: [],
      childTableHeaderList: [],
      alertFlagOptions: [
        {
          name: "汇总信息",
          code: "Header",
        },
        {
          name: "检测信息",
          code: "Item",
        },
      ],
      // 附件信息
      fileTableData: [],
      // 波动原因备注
      remarkForm: {
        griCode: "",
        griName: "",
        plantName: "",
        indicators: "",
        gapReason: "",
        inspectCode: "",
        reportId: "",
        inspectId: "",
      },
      categoryList2: [],
      categoryList3: [],
      windowTimeList: [],
      typeLists: [],
      expandKeys: [],//展开行数据存储
      activeName: "CURRENT_WINDOW",
      defaultMonth: "",//查询条件中,isDefault为true的月份
      father_month: "",//列表中父元素行的月份
      rowId: "",
      type: "",//判断是子元素还是父元素的波动原因修改
      detailObj: null,//传给nutrition修改弹窗的值
      griName: "",
      expand: false,
      tabLists: [
        {
          label: "窗口期数据",
          key: "CURRENT_WINDOW",
          currentDetailList: [],
          tableHeaderList: [],
        },
        {
          label: "全量最新数据",
          key: "All",
          currentDetailList: [],
          tableHeaderList: [],
        },
        {
          label: "已发布数据",
          key: "RELEASED",
          currentDetailList: [],
          tableHeaderList: [],
        },
      ],
      reportId: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    console.log("🚀 ~ file: griNutritionAnalysis.vue:279 ~ beforeRouteEnter ~ to:", to)
    console.log("🚀 ~ file: griNutritionAnalysis.vue:279 ~ beforeRouteEnter ~ from:", from)
    next(vm => {
      if (from.path === '/nutritionTodo'&&to.query.flag==='NUTRITION_LAB_COMMENTS') {
        vm.queryCondition.alertFlag = 'Item'
      }
    })
  },
  mounted() {
    this.getWindowTimeList()
    this.getCategory1()
    var permission = JSON.parse(localStorage.getItem('ms_Permission'))
    console.log("🚀 ~ file: griNutritionAnalysis.vue:239 ~ created ~ permission:", permission)
    if (permission.indexOf('NUTR_REPORT_REMARK_GAP_REASON') != -1) {
      this.isEdit = true
    } else {
      this.isEdit = false
    }
    if (permission.indexOf('NUTRITION_LAB_AUDIT') != -1) {
      this.alertFlagOptions = [
        {
          name: "检测信息",
          code: "Item",
        },
      ]
    } else {
      this.alertFlagOptions = [
        {
          name: "汇总信息",
          code: "Header",
        },
        {
          name: "检测信息",
          code: "Item",
        },
      ]
    }
  },
  methods: {
    queryData(val) {
      console.log('this.queryCondition.windowTimeList', this.queryCondition.windowTimeList)
      if (this.queryCondition.windowTimeList.length == 0) {
        this.$message.error('请选择窗口期')
        return false
      }
      this.expandKeys = []
      if (this.activeName == 'CURRENT_WINDOW') {
        this.$set(this.queryCondition, 'dataSource', 'CURRENT_WINDOW')
        this.$set(this.queryCondition, 'status', '')
      } else if (this.activeName == 'RELEASED') {
        this.$set(this.queryCondition, 'dataSource', '')
        this.$set(this.queryCondition, 'status', 'RELEASED')
      } else if (this.activeName == 'All') {
        this.$set(this.queryCondition, 'dataSource', '')
        this.$set(this.queryCondition, 'status', '')
      }
      nutriApi.findAnalysisPage(this.queryCondition).then((res) => {
        console.log("🚀 ~ file: griNutritionAnalysis.vue:306 ~ nutriApi.findAnalysisPage ~ res:", res)
        res.resultData.forEach(ele => {
          this.$set(ele, 'expand', false)// 表示当前行是闭合的，不设置这个等下展开后就没法闭合了
        })
        this.tabLists.forEach(ele => {
          if (ele.key == this.activeName) {
            this.$set(ele, 'currentDetailList', res.resultData)
            this.$set(ele, 'tableHeaderList', res.tableHeaderList)
          }
        })
        this.totalCount = res.totalCount
        if (val && val == 'dialog') {
          var nutritionCurData = JSON.parse(sessionStorage.getItem('nutritionCurData'))
          console.log("🚀 ~ file: griNutritionAnalysis.vue:528 ~ closeDetail ~ nutritionCurData:", nutritionCurData)
          var arr = res.resultData.filter(ele => {
            return ele.WINDOW_TIME == nutritionCurData.windowTime && ele.GRI_CODE == nutritionCurData.griCode && ele.COOK_CODE == nutritionCurData.cookCode
          })
          console.log("🚀 ~ file: griNutritionAnalysis.vue:287 ~ arr ~ arr:", arr)
          this.expandChange(arr[0], null)
        }
      });
    },
    expandChange(row, expandRow) {
      console.log("🚀 ~ file: griNutritionAnalysis.vue:358 ~ expandChange ~ expandRow:", expandRow)
      console.log("🚀 ~ file: griNutritionAnalysis.vue:336 ~ expandChange ~ row:", row)
      // console.log('this.rowId', this.rowId)
      console.log('expandChange this.expandKeys', this.expandKeys)
      this.father_month = row.WINDOW_TIME
      this.griName = row.DESCRIBE
      this.reportId = row.REPORT_ID
      // 先判断该行是否已经展开了
      this.expandKeys = []
      if (!row.expand) {
        console.log('row.expand', row.expand)
        row.expand = true
        this.expandKeys.push(row.REPORT_ID)
        var obj = {
          windowTime: row.WINDOW_TIME,
          griCode: row.GRI_CODE,
          cookCode: row.COOK_CODE,
          inspectId: row.INSPECT_ID
        }
        sessionStorage.setItem('nutritionCurData', JSON.stringify(obj))
        this.getChild(row)
      } else {
        console.log('row.expand1', row.expand)
        row.expand = false
        this.expandKeys = []
      }
      this.expand = row.expand
      console.log('this.tabLists', this.tabLists)
    },
    // 获取子列表数据
    getChild(row) {
      nutriApi.getReportFacilityDetailListByReportId({
        windowTimeList: this.queryCondition.windowTimeList,
        reportId: row.REPORT_ID,
        alertFlag: this.queryCondition.alertFlag,
      }).then((res) => {
        console.log("🚀 ~ file: griNutritionAnalysis.vue:342 ~ expandChange ~ res:", res)
        this.childTableHeaderList = res.data.tableHeaderList
        this.tabLists.forEach(ele => {
          if (ele.key == this.activeName) {
            ele.currentDetailList.forEach(item => {
              if (item.REPORT_ID === row.REPORT_ID) {
                var arr = [...res.data.resultData]
                this.$set(item, 'childDetailList', arr)
              }
            })
          }
        })
        this.$nextTick(() => {
          this.cellClassName()
        })
      });
    },
    handleClick(tab, event) {
      this.activeName = tab.name
      this.queryCondition.pageSize = 15
      this.queryCondition.pageNum = 1
      this.queryData()
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'GRI_CODE' && row.LESS_THAN_ONE_HUNDRED_PERCENT === 'Y') {
        return 'nutritionRedClass'
      }
    },
    // 获取窗口期下拉值
    getWindowTimeList() {
      nutriApi.getWindowTimeList().then((res) => {
        console.log("🚀 ~ file: nutritionDetection.vue:528 ~ nutriApi.getWindowTimeList ~ res:", res)
        this.windowTimeList = res.data;
        res.data.forEach(ele => {
          if (ele.isDefault) {
            this.queryCondition.windowTimeList.push(ele.code)
            this.defaultMonth = ele.code
          }
        })
        this.queryData()
        console.log(' this.defaultMonth', this.defaultMonth)
      });
    },
    getCategory1() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        var pid
        res.data.forEach(ele => {
          if (ele.code == '10' && ele.name == 'Food') {
            pid = ele.tmCategoryId
          }
        })
        this.getCategory2(pid)
      });
    },
    getCategory2(pid) {
      apiService.findCategory({ categoryLevel: 2, pid: pid }).then((res) => {
        console.log("🚀 ~ file: nutritionDetection.vue:507 ~ apiService.findCategory ~ res:", res)
        this.categoryList2 = res.data;
      });
    },
    changeCategory2() {
      this.categoryList3 = []
      var category2Codes = []
      this.categoryList2.forEach(ele => {
        if (this.queryCondition.categoryLevel2CodesList.includes(ele.code)) {
          category2Codes.push(ele.tmCategoryId)
        }
      })
      apiService.findCategory({ categoryLevel: 3, pidList: category2Codes }).then((res) => {
        console.log("🚀 ~ file: nutritionDetection.vue:515 ~ apiService.findCategory ~ res:", res)
        this.categoryList3 = res.data;
      });
    },
    getInputChoiceValues() {
      inputChoiceService.listInputChoice().then((res) => {
        console.log("🚀 ~ file: nutritionDetail.vue:338 ~ inputChoiceService.listInputChoice ~ res:", res)
        this.typeLists = res.data.filter(ele => {
          return ele.fieldName === 'ATTACHMENT_TYPE' && ele.tableName === 'TT_NUTR_INSPECT'
        })
        console.log("🚀 ~ file: nutritionDetail.vue:341 ~ inputChoiceService.listInputChoice ~ this.typeLists:", this.typeLists)
      });
    },

    goToNutritionDetail(row) {
      console.log("🚀 ~ file: griNutritionAnalysis.vue:366 ~ goToNutritionDetail ~ row:", row)
      var permission = JSON.parse(localStorage.getItem('ms_Permission'))
      console.log("🚀 ~ file: griNutritionAnalysis.vue:450 ~ goToNutritionDetail ~ permission:", permission)
      var type = ''
      if (permission.indexOf('NUTRITION_CQS_OWNER_AUDIT') != -1 && (row.INSPECT_STATUS == 'Uploaded' || row.INSPECT_STATUS == 'Finalized')) {
        type = 'edit'
      } else if (permission.indexOf('NUTRITION_LAB_AUDIT') != -1 && (row.INSPECT_STATUS == 'Released' || row.INSPECT_STATUS === 'Uploaded')) {
        type = 'edit'
      } else {
        type = 'view'
      }
      this.$router.push({
        path: "/nutritionInspect/detail",
        query: {
          type: type,
          id: row.INSPECT_ID
        }
      })
    },
    onViewDetail(row) {
      console.log("🚀 ~ file: griNutritionAnalysis.vue:400 ~ onViewDetail ~ row:", row)
      var permission = JSON.parse(localStorage.getItem('ms_Permission'))
      console.log("🚀 ~ file: griNutritionAnalysis.vue:486 ~ onViewDetail ~ permission:", permission)
      var type = ''
      if (permission.indexOf('NUTR_REPORT_EDIT_DATA') != -1) {
        if (this.father_month == this.defaultMonth) {
          type = 'edit'
        } else {
          type = 'view'
        }
      } else {
        type = 'view'
      }
      var params = Object.assign({}, this.queryCondition)
      params.defaultMonth = this.defaultMonth
      console.log("🚀 ~ file: griNutritionAnalysis.vue:418 ~ onViewDetail ~ params:", params)
      sessionStorage.setItem('rememberQuery', JSON.stringify(params))
      nutriApi.getNutritionDetail(row.INSPECT_ID, 'N').then(res => {
        console.log("🚀 ~ file: nutritionDetail.vue:309 ~ nutriApi.getNutritionDetail ~ res:", res)
        if (res.code == '200') {
          var result = res.data
          var obj = {
            windowTime: result.windowTime,
            versionText: result.versionText,
            fiveBitCode: result.fiveBitCode,
            fiveBitCodeName: result.fiveBitCodeName,
            facilityName: result.facilityName,
            cookCodeText: result.cookCodeText,
            updateReason: result.updateReason,
            currentDetailList: result.currentDetailList,
            tableHeaderList: result.tableHeaderList,
            inspectId: row.INSPECT_ID,
            type: type,
          }
          console.log("🚀 ~ file: griNutritionAnalysis.vue:433 ~ nutriApi.getNutritionDetail ~ obj:", obj)
          this.detailObj = JSON.stringify(obj)
          this.dialogVisible3 = true
        }
      })
      // console.log("🚀 ~ file: griNutritionAnalysis.vue:425 ~ onViewDetail ~ row:", row)
      // var permission = JSON.parse(localStorage.getItem('ms_Permission'))
      // var type = ''
      // console.log("🚀 ~ file: griNutritionAnalysis.vue:373 ~ onViewDetail ~ permission:", permission)
      // if (permission.indexOf('NUTR_REPORT_EDIT_DATA') != -1) {
      //   if (this.father_month == this.defaultMonth) {
      //     type = 'edit'
      //   } else {
      //     type = 'view'
      //   }
      // } else {
      //   type = 'view'
      // }
      // this.$router.push({
      //   path: "/nutritionAnalysis/detail",
      //   query: {
      //     type: type,
      //     id: row.INSPECT_ID
      //   }
      // })
    },
    onViewFile(row) {
      nutriApi.getNutritionDetail(row.INSPECT_ID).then(res => {
        console.log("🚀 ~ file: griNutritionAnalysis.vue:361 ~ nutriApi.getNutritionDetail ~ res:", res)
        if (res.code == '200') {
          this.dialogVisible2 = true
          this.fileTableData = res.data.attachmentList
          var params = Object.assign({}, this.queryCondition)
          console.log("🚀 ~ file: griNutritionAnalysis.vue:418 ~ onViewDetail ~ params:", params)
          sessionStorage.setItem('rememberQuery', JSON.stringify(params))
        }
      })
    },
    onViewReason(row, prop, label) {
      console.log("🚀 ~ file: griNutritionAnalysis.vue:384 ~ onViewReason ~ prop:", prop)
      console.log("🚀 ~ file: griNutritionAnalysis.vue:384 ~ onViewReason ~ row:", row)
      this.dialogVisible1 = true
      this.isDisplay = false
      this.remarkForm.griCode = row.GRI_CODE
      this.remarkForm.griName = row.DESCRIBE
      this.remarkForm.indicators = label
      this.remarkForm.gapReason = row[prop + '_GAP_REASON']
      this.remarkForm.inspectCode = prop
      this.remarkForm.reportId = row.REPORT_ID
      this.type = 1
      var params = Object.assign({}, this.queryCondition)
      console.log("🚀 ~ file: griNutritionAnalysis.vue:418 ~ onViewDetail ~ params:", params)
      sessionStorage.setItem('rememberQuery', JSON.stringify(params))
    },
    onViewChildReason(row, prop, label) {
      console.log("🚀 ~ file: griNutritionAnalysis.vue:402 ~ onViewChildReason ~ prop:", prop)
      console.log("🚀 ~ file: griNutritionAnalysis.vue:402 ~ onViewChildReason ~ row:", row)
      this.dialogVisible1 = true
      this.isDisplay = true
      this.remarkForm.griCode = row.FIVE_BIT_CODE
      this.remarkForm.griName = this.griName
      this.remarkForm.plantName = row.FACILITY_NAME
      this.remarkForm.indicators = label
      this.remarkForm.gapReason = row[prop + '_GAP_REASON']
      this.remarkForm.inspectCode = prop
      this.remarkForm.inspectId = row.INSPECT_ID
      this.type = 2
      var params = Object.assign({}, this.queryCondition)
      console.log("🚀 ~ file: griNutritionAnalysis.vue:418 ~ onViewDetail ~ params:", params)
      sessionStorage.setItem('rememberQuery', JSON.stringify(params))
    },
    onFinalization() {
      this.isFinalDisabled = true
      this.isFinalLoading = true
      nutriApi.confirmEdition().then(res => {
        console.log("🚀 ~ file: griNutritionAnalysis.vue:370 ~ nutriApi.confirmEdition ~ res:", res)
        this.isFinalDisabled = false
        this.isFinalLoading = false
        if (res.code == '200') {
          this.$message.success('定版成功')
          this.queryData()
        }
      }).catch(error => {
        this.isFinalDisabled = false
        this.isFinalLoading = false
      })
    },
    onPublish() {
      this.isPublishDisabled = true
      this.isPublishLoading = true
      nutriApi.nutrReportRelease().then(res => {
        console.log("🚀 ~ file: griNutritionAnalysis.vue:378 ~ nutriApi.nutrReportRelease ~ res:", res)
        this.isPublishDisabled = false
        this.isPublishLoading = false
        if (res.code == '200') {
          this.$message.success('发布成功')
          this.queryData()
        }
      }).catch(error => {
        this.isPublishDisabled = false
        this.isPublishLoading = false
      })
    },
    onExport() {
      nutriApi.reportListDownload(this.queryCondition).then(res => {
        console.log('res', res)
      })
    },
    onDownload(row) {
      fileService.downloadFile(row).then(res => {
        console.log('res', res)
      })
    },
    onClose2() {
      this.dialogVisible2 = false
      // var rememberQuery = JSON.parse(sessionStorage.getItem('rememberQuery'))
      // this.queryCondition = Object.assign({}, rememberQuery)
      // this.queryData('dialog')
    },
    closeDetail() {
      this.dialogVisible3 = false
      this.detailObj = null
      if (this.expand) {
        var rememberQuery = JSON.parse(sessionStorage.getItem('rememberQuery'))
        this.queryCondition = Object.assign({}, rememberQuery)
        this.queryData('dialog')
      } else {
        this.queryData()
      }
    },
    onClose3() {
      this.dialogVisible3 = false
      this.detailObj = null
    },
    onSaveNote() {
      console.log('是否展开了', this.expand)
      this.$refs['remarkForm'].validate((valid) => {
        if (valid) {
          if (this.type === 1) {
            this.isSaveDisabled = true
            this.isSaveLoading = true
            nutriApi.remarkReportGapReason({
              reportId: this.remarkForm.reportId,
              inspectCode: this.remarkForm.inspectCode,
              gapReason: this.remarkForm.gapReason,
            }).then(res => {
              console.log("🚀 ~ file: griNutritionAnalysis.vue:428 ~ onSaveNote ~ res:", res)
              this.isSaveDisabled = false
              this.isSaveLoading = false
              if (res.code == '200') {
                this.$message.success('保存成功')
                this.onClose1()
                if (this.expand) {
                  var rememberQuery = JSON.parse(sessionStorage.getItem('rememberQuery'))
                  this.queryCondition = Object.assign({}, rememberQuery)
                  this.queryData('dialog')
                } else {
                  this.queryData()
                }
              }
            }).catch(error => {
              this.isSaveDisabled = false
              this.isSaveLoading = false
            })
          } else if (this.type === 2) {
            this.isSaveDisabled = true
            this.isSaveLoading = true
            nutriApi.remarkInspectGapReason({
              reportId: this.reportId,
              inspectId: this.remarkForm.inspectId,
              inspectCode: this.remarkForm.inspectCode,
              gapReason: this.remarkForm.gapReason,
            }).then(res => {
              console.log("🚀 ~ file: griNutritionAnalysis.vue:428 ~ onSaveNote ~ res:", res)
              this.isSaveDisabled = false
              this.isSaveLoading = false
              if (res.code == '200') {
                this.$message.success('保存成功')
                this.onClose1()
                if (this.expand) {
                  var rememberQuery = JSON.parse(sessionStorage.getItem('rememberQuery'))
                  this.queryCondition = Object.assign({}, rememberQuery)
                  this.queryData('dialog')
                } else {
                  this.queryData()
                }
              }
            }).catch(error => {
              this.isSaveDisabled = false
              this.isSaveLoading = false
            })
          }
        }
      })
    },
    onClose1() {
      this.dialogVisible1 = false
      this.remarkForm = {
        griCode: "",
        griName: "",
        plantName: "",
        indicators: "",
        gapReason: "",
        inspectCode: "",
        reportId: "",
        inspectId: "",
      }
      this.isDisplay = false
      this.type = ''
      // var rememberQuery = JSON.parse(sessionStorage.getItem('rememberQuery'))
      // this.queryCondition = Object.assign({}, rememberQuery)
      // this.queryData('dialog')
    },
    onSearch() {
      this.queryCondition.pageNum = 1;
      this.queryData()
    },
    onReset() {
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        windowTimeList: [],
        griCode: "",
        griName: "",
        griDescription: "",
        categoryLevel2CodesList: [],
        categoryLevel3CodesList: [],
      }
      this.windowTimeList.forEach(ele => {
        if (ele.isDefault) {
          this.queryCondition.windowTimeList.push(ele.code)
          this.defaultMonth = ele.code
        }
      })
      this.queryData()
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-table__expand-icon {
  color: #f8ab01 !important;
}
/deep/.el-table__expand-icon > .el-icon {
  color: #f8ab01 !important;
  position: initial !important;
  top: 0 !important;
  left: 0 !important;
  margin-left: 0 !important;
  margin-top: 0 !important;
}
</style>
  